import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

/**
 * Read-only view of the booking's frozen question/answer snapshot. Renders
 * nothing when the booking has no answers (every pre-Iteration-80 booking).
 *
 * Photos are private: they're fetched with the caller's auth header and opened
 * as a blob URL, so no token is ever put in a link.
 */
export const BookingAnswersView = ({ answers = [], authHeader, testId = "booking-answers" }) => {
  const [busy, setBusy] = useState("");
  const rows = (answers || []).filter((a) => a && (a.answer || (a.photo_urls || []).length));
  if (!rows.length) return null;

  const openPhoto = async (path) => {
    setBusy(path);
    try {
      const r = await axios.get(`${process.env.REACT_APP_BACKEND_URL}${path}`, {
        headers: authHeader ? authHeader() : {},
        responseType: "blob",
      });
      window.open(URL.createObjectURL(r.data), "_blank", "noopener");
    } catch (e) {
      toast.error("Couldn't open that photo");
    } finally {
      setBusy("");
    }
  };

  return (
    <div className="mt-3 rounded-lg border p-3" data-testid={testId}
         style={{ borderColor: "var(--gf-border)", background: "var(--gf-bg-soft)" }}>
      <div className="text-[10px] uppercase tracking-[0.2em] mb-2" style={{ color: "var(--gf-text-muted)" }}>
        Booking answers
      </div>
      <dl className="space-y-2">
        {rows.map((a, i) => (
          <div key={a.question_id || i} data-testid={`${testId}-row-${a.question_id || i}`}>
            <dt className="text-[11px]" style={{ color: "var(--gf-text-muted)" }}>{a.label}</dt>
            <dd className="text-sm" style={{ color: "var(--gf-text)" }}>
              {a.answer || null}
              {(a.photo_urls || []).length > 0 && (
                <div className="mt-1.5 flex flex-wrap gap-3">
                  {a.photo_urls.map((u) => (
                    <button key={u} type="button" onClick={() => openPhoto(u)} disabled={busy === u}
                            data-testid={`${testId}-photo-btn`}
                            className="text-xs underline disabled:opacity-50" style={{ color: "var(--gf-accent)" }}>
                      {busy === u ? "Opening…" : "View photo"}
                    </button>
                  ))}
                </div>
              )}
            </dd>
          </div>
        ))}
      </dl>
    </div>
  );
};

export default BookingAnswersView;
